import { render, staticRenderFns } from "./serviceItem.vue?vue&type=template&id=7539d4a0&"
import script from "./serviceItem.js?vue&type=script&lang=js&"
export * from "./serviceItem.js?vue&type=script&lang=js&"
import style0 from "./serviceItem.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7539d4a0')) {
      api.createRecord('7539d4a0', component.options)
    } else {
      api.reload('7539d4a0', component.options)
    }
    module.hot.accept("./serviceItem.vue?vue&type=template&id=7539d4a0&", function () {
      api.rerender('7539d4a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/services/serviceItem/serviceItem.vue"
export default component.exports